import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../images/image_empty_error.png';

export default function Members({ event, menhirUrl }) {
    return (
        <div>
            <WeezHeader title={<Trans i18nKey="ticket.members.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={<Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={`${menhirUrl}/members_list.php?id_evenement=${event.id}`} />}
            />
        </div>
    );
}

Members.propTypes = {
    event: PropTypes.object.isRequired,
    menhirUrl: PropTypes.string.isRequired
};
